<template>
  <div>
    <b-row class="mt-5">
      <b-col xxs="12" md="8" lg="6" class="mx-auto">
      

        <b-card>

          <div class="row">
            <div class="col-12">
              <h5 class="font-weight-bold m-0">Application Update</h5>
              <h6 class="mb-3 text-muted">{{ appName }}</h6>
            </div>
            
          </div>

          <hr>

            

          <div class="row mt-5">
            <div class="col-12">
              <p>An application update is required,<br> click below to proceed with update</p>
              <button class="btn btn-primary" v-on:click="reload">Update</button>
            </div>
            
          </div>
         
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appName: process.env.VUE_APP_APP_NAME
    };
  },
  methods:{
    reload(){
      location.reload(true);
    }
  }
};
</script>
